// extracted by mini-css-extract-plugin
export default {"balanceContainer":"MyBalance__balanceContainer--nW7","balanceHeader":"MyBalance__balanceHeader--fXQ","balance":"MyBalance__balance--tPv"};